import {Box, FormGroup, FormControlLabel, Checkbox, Typography} from '@mui/material';

interface Data {
  title: string;
  choices: Array<string> | Array<{key: string; value: string}>;
  selected: Array<string>;
  columns?: number;
  callback?: (roles: Array<string>) => void;
}

const CheckBoxIcon = () => (
  <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect width='20' height='20' fill='white' />
    <rect width='20' height='20' fill='white' />
  </svg>
);

const Checkmark = () => (
  <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M5 9.31034L8.31034 13.0345L15.3448 6'
      stroke='#450A0A'
      strokeWidth='3'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const CheckboxFilter = ({title, choices, selected, callback, columns = 2}: Data) => {
  // const [checked, setChecked] = useState<string[]>(selected ? [...selected] : []);
  const handleCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    let selections: string[];
    if (event.target.checked && !selected?.includes(event.target.value)) {
      selections = [...selected, event.target.value];
    } else {
      selections = selected.filter((x) => x !== event.target.value);
    }
    if (callback) {
      callback(selections);
    }
  };

  return (
    <Box>
      {!!title?.length && <Typography variant='h5'>{title}</Typography>}
      <Box
        sx={{
          columns: columns,
          p: 0,
          borderRadius: 1,
        }}
      >
        <FormGroup>
          {choices.map((item, index) => (
            <FormControlLabel
              key={index}
              control={
                <Checkbox
                  value={typeof item === 'string' ? item : item.key}
                  onChange={handleCheck}
                  color='secondary'
                  checked={selected?.includes(typeof item === 'string' ? item : item.key)}
                  icon={<CheckBoxIcon />}
                  checkedIcon={<Checkmark />}
                />
              }
              label={
                <Typography variant='h6' fontWeight={600}>
                  {typeof item === 'string' ? `${item}` : `${item.key} ${item.value}`}
                </Typography>
              }
            />
          ))}
        </FormGroup>
      </Box>
    </Box>
  );
};
